import { EscalationsGroupInterface, NodeInterface } from "@swivl-mono/types";
import { Dropdown, SelectableOption, Spinner } from "@swivl-mono/ui";
import EscalationsModel from "../../../../Models/Escalations/Escalations.Model";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";



const Escalation = {
  Type: "escalation",
  Empty: function() {
          return {
              "id": RandomId(6),
              "type": Escalation.Type,
              "delay": 0,
              "showTyping":false,
              "groupSlug": "",
              "groupName":"Not Set",
              "onCompleteGoto": null,
              "allowTakeover":true
            }
    },

  PlumbData: function(node:NodeInterface) {
    // let node  = JSON.parse(JSON.stringify(nodeParam))
    // var text = VarsModel.replaceVariableNameInString(node.message, "*", "*")
    // node.escalationName  = text.length > 18 ? text.substring(0,15) + "..." : text;


    return TabNodeLayoutData({
      node: node,
      label:"Escalation",
      title: node.groupName ,
      baseWidth: 160,
      tabs:[{id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto,}]
    });


  },

   InspectorPanel: function EscalationInspectorPanel(props:any) {
      const escalationGroups = EscalationsModel.useState(s => s.escalationGroups);
      // eslint-disable-next-line react/jsx-pascal-case
      return <Escalation.Internal_InspectorPanel {...props} escalationGroups={escalationGroups} />
   },
   
   
   Internal_InspectorPanel: class EscalationInspectorPanel extends NodePanel{
    hasLoadedConversations = false; 
     constructor(props:any) {       super(props);
        this.state = {groups:[], isLoading:true}
        this.hasLoadedConversations = false;
        this.getEscalationName  = this.getEscalationName.bind(this)
        this.onEscalationChange = this.onEscalationChange.bind(this)
    }

     componentDidMount() {
        EscalationsModel.loadGroups()
        
     }
     componentDidUpdate() {
  
        
     }

     getEscalationName(groupSlug:string) {
      const {escalationGroups} = this.props as any; 
      if (!escalationGroups || !escalationGroups.length) {
        return ""
      } 
      for (let index = 0; index < escalationGroups.length; index++) {
        if (escalationGroups[index].slug=== groupSlug) {
          return escalationGroups[index].name
        } 
      }
     }

     onEscalationChange(event:any) {
      const target = event.target;
      const value = (target.type && target.type === 'checkbox') ? target.checked : target.value;
      // const name = target.name;
      let node =  JSON.parse(JSON.stringify(this.props.node));
      node.groupSlug = value; 
      node.groupName = this.getEscalationName(value); 
      // set(node, name, value);
      // set(node, "groupName", );
      this.props.updateNode(node, this.props.node)
     }
     

    render() {
        const {escalationGroups} = this.props as any; 
        

        let groupsDropdown; 

        if (escalationGroups) { 
            if (escalationGroups.length === 0) {
                groupsDropdown = <div>No groups created. Please go in to your <a href="/settings/escalations">escalations settings </a>and create a group.</div>
            } else {
                const options:SelectableOption[] = escalationGroups.map((group:EscalationsGroupInterface)=> {return {value: group.slug, label: group.name}})
                groupsDropdown = <div className="slackDropdown"><Dropdown options={options} value={this.props.node.groupSlug} onChange={this.onEscalationChange} name="groupSlug" /></div>

            // if (slackConversations && slackConversations.channels && slackConversations.channels.length > 0) {
            //     for (var i=0; i < slackConversations.channels.length; i++) {
            //       var channel = slackConversations.channels[i];
            //       options.push({value: channel.id, id: channel.id, name: channel.name})
            //     }
            //   }
            }
        } else  {
            groupsDropdown =  <span className="loading yellow"><Spinner /></span>
        }
        // if (this.state.hasLoaded) {
        //     if (slackConversations == null || !slackConversations.channels || slackConversations.channels.length == 0 ) {
        //    channelOptions = (<div><span className="channelSymbol"># </span><input className="slackChannelInput" value={this.props.node.channel} onChange={this.onChange} name="channel"></input><div>Set your slack token in <a href="/settings/server" className="highlightLink">Account Settings.</a></div></div>);
        //     } else {
        //      channelOptions = <div className="slackDropdown"><SSDropdown options={options} value={this.props.node.channel} onChange={this.onChange} name="channel" selectedValue={this.props.node.channel}/></div>
        //    }
        //  } else {
        //    channelOptions = <span className="loading yellow"><Spinner /></span>
        //  }
   
   
        
        return  <div>
                <div className="panel escalation_panel">
                    <InspectorNodeHeader
                      title="Escalations"/> 
                        <label>Send To Group</label>
                    {groupsDropdown}


                </div>
                <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
              </div>;
      }

   }
}
export default Escalation;
